import { apiClient } from '../../services/api';

/**
 * Get approval queue (agent tasks pending approval)
 */
export async function getApprovalQueue(options = {}) {
  const params = new URLSearchParams();
  if (options.status) params.append('status', options.status);
  if (options.agent) params.append('agent', options.agent);
  if (options.priority) params.append('priority', options.priority);

  const queryString = params.toString();
  const url = queryString ? `/attorney/approval-queue?${queryString}` : '/attorney/approval-queue';

  const response = await apiClient.get(url);
  return response.data;
}

/**
 * Get a single task for approval
 */
export async function getApprovalTask(taskId) {
  const response = await apiClient.get(`/attorney/approval-queue/${taskId}`);
  return response.data;
}

/**
 * Approve a task
 * Backend expects action in request body, not URL
 */
export async function approveTask(taskId, data = {}) {
  const response = await apiClient.post(`/attorney/approval-queue/${taskId}`, {
    action: 'approve',
    notes: data.notes,
    modifications: data.modifications
  });
  return response.data;
}

/**
 * Reject a task
 * Backend expects action in request body, not URL
 */
export async function rejectTask(taskId, data) {
  const response = await apiClient.post(`/attorney/approval-queue/${taskId}`, {
    action: 'reject',
    reason: data.reason,
    notes: data.notes
  });
  return response.data;
}

/**
 * Assign a task to an attorney
 */
export async function assignTask(taskId, data = {}) {
  const response = await apiClient.post(`/attorney/approval-queue/${taskId}`, {
    action: 'assign',
    assignTo: data.assignTo
  });
  return response.data;
}

export default {
  getApprovalQueue,
  getApprovalTask,
  approveTask,
  rejectTask,
  assignTask
};
